module.exports = __webpack_public_path__ + "static/img/gpt33.ac39a9e6.png";